import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnglish = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 31,
	viewBox: "0 0 30 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.15 6.37632C12.9 5.02632 11.2 4.12632 9.4 3.82632C7.6 3.52632 5.35 2.77632 3.5 1.72632V7.07632H0.75V27.7763H11.55C12.95 30.2263 16.55 30.2263 17.95 27.7763H28.75V7.07632H26V4.07632L19.15 5.92632",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 9.97632V22.4263C6.25 23.9763 9.35 24.7763 12.55 24.7763H26V9.97632",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.75 21.8764V14.5264",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2 2.97632L19.75 5.27632",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.45 14.5264L7.25 16.6764L8.95 12.2264L18.9 1.07641C19.25 0.676413 19.85 0.626413 20.25 1.02641L21.35 2.02641C21.75 2.37641 21.8 2.97641 21.4 3.37641L11.45 14.5264Z",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgEnglish;
